import { FunctionalComponent, h } from 'preact';

type AppProps = {
	data : olympicJSON;
	linkSuffix : string;
	placeholder : string;
}

type olympicIncluded = {
	type : string;
	id : string;
	links : {};
	attributes : {
		description? : string;
		uri? : {
			url : string;
		};
	};
	relationships : {
		image : {
			data : {
				meta : {
					alt : string;
					width : number;
					height : number;
				} | null;
			};
		};
	};
}

export type olympicJSON = {
	data : {
		type : string;
		id : string;
		attributes : {
			title : string;
			path : {
				url : string;
			};
		};

	}[];
	included : olympicIncluded[];
}

const NewsFeed : FunctionalComponent<AppProps> = ( { data, linkSuffix, placeholder } ) => {
	const images = data.included.reduce( ( acc : olympicIncluded[], img : olympicIncluded ) => {
		if ( img.type === 'file--file' ) {
			acc.push( img );
		}
		return acc;
	}, [] );

	return (
		<div style={{ overflowX : 'scroll', overflowY : 'hidden', margin : '0px 12px 0px' }}>
			<div style={{
				display      : 'flex',
				flexFlow     : 'row nowrap',
				justifyItems : 'center',
				alignContent : 'center',
				padding      : '6px 0',
				marginBottom : 0
			}} role='list'>
				{data.data.map( ( { attributes }, k ) => {
					return (
						<div key={k + attributes.title} style={{
							display    : 'flex',
							flexFlow   : 'row no-wrap',
							margin     : '6px 12px 6px 0px',
							minHeight  : 178,
							boxSizing  : 'border-box',
							lineHeight : '1.1rem',
							fontSize   : 14,
							fontFamily : 'Arial, Verdana, sans-serif',
						}} role='listItem'>
							<a href={attributes.path.url + linkSuffix} style={{
								display        : 'block',
								flex           : '0 1 auto',
								minWidth       : 200,
								color          : 'hsl(220, 50%, 40%)',
								textDecoration : 'inherit',
								marginBottom   : 0
							}} rel='noopener' target='_blank'>
								{( images[ k ] && images[ k ].attributes.uri )
								 //@ts-ignore
								 ? <img src={images[ k ].attributes.uri.url} alt={images[ k ].attributes.description} style={{
										width        : 'auto',
										height       : 120,
										marginBottom : 0
									}} />
								 : <img src={placeholder} alt='' style={{
										width        : 'auto',
										height       : 120,
										marginBottom : 0
									}} />}
								<div style={{ marginBottom : 0 }}>{attributes.title}</div>
							</a>
						</div>
					);
				} )}
			</div>
		</div>
	);
};

export default NewsFeed;
